export const DISPLAY_FONTS = [
  "Bungee", "Silkscreen", "Press Start 2P", "VT323", "Bebas Neue", "Anton", "Oswald", "Russo One", "Black Ops One",
  "Righteous", "Monoton", "Permanent Marker", "Pirata One", "UnifrakturMaguntia", "Pacifico", "Rubik Mono One",
];
export const BODY_FONTS = [
  "Space Mono", "Courier Prime", "IBM Plex Mono", "Plus Jakarta Sans", "Outfit", "Manrope", "DM Sans", "Work Sans",
  "Rubik", "Barlow", "Archivo",
];

const FACEPLATE_OPTIONS = [["custom", "Theme colors (Radio console color)"], ["brushed_chrome", "Brushed chrome"], ["candy_red", "Candy red"],
  ["matte_black", "Matte black"], ["carbon_fiber", "Carbon fiber"], ["gold_flake", "Gold flake"], ["candy_purple", "Candy purple"]];
export const faceplateClass = (name) => (name && name !== "custom" ? `faceplate-${name.replace(/_/g, "-")}` : "");

// Control definitions for the Studio Theme tab: [key, label, type, extra]
export const THEME_SECTIONS = [
  ["Main player", [
    ["player_style", "Player style", "select", [["alpine", "Classic: 90s Alpine car deck"], ["pioneer", "New: Pioneer touchscreen head unit"]]],
  ]],
  ["Background & fades", [
    ["bg_mode", "Background style", "select", [["solid", "Solid color"], ["linear", "Gradient fade"], ["radial", "Radial glow"]]],
    ["background", "Background color", "color"],
    ["background_2", "Gradient 2nd color", "color", { show: (t) => t.bg_mode !== "solid" }],
    ["bg_angle", "Gradient angle", "range", { min: 0, max: 360, unit: "°", show: (t) => t.bg_mode === "linear" }],
    ["dot_grid", "Dot grid texture", "switch"],
    ["dot_grid_opacity", "Dot grid strength", "range", { min: 0, max: 40, unit: "%", show: (t) => t.dot_grid }],
    ["bg_image_opacity", "Background photo visibility", "range", { min: 0, max: 100, unit: "%" }],
    ["fade_color", "Photo fade color", "color"],
    ["fade_strength", "Photo fade strength", "range", { min: 0, max: 100, unit: "%" }],
  ]],
  ["Faceplates", [
    ["deck_faceplate", "Car deck faceplate", "select", FACEPLATE_OPTIONS],
    ["video_faceplate", "Video player faceplate", "select", FACEPLATE_OPTIONS],
  ]],
  ["Text colors", [
    ["text", "Main text", "color"], ["muted", "Secondary text", "color"], ["label", "Labels & LCD text", "color"],
    ["station_name", "Station name", "color"], ["song_title", "Song title", "color"], ["song_title_fade", "Song title fade", "color"],
  ]],
  ["Console & player", [
    ["panel", "Radio console", "color"], ["lcd", "LCD screens", "color"], ["button", "Buttons", "color"],
    ["play_button", "Button icons / play", "color"], ["bar", "Bottom player bar", "color"], ["card_border", "Card borders", "color"],
    ["progress", "Tuner needle / progress", "color"], ["volume", "Volume bar", "color"],
  ]],
  ["Visualizer", [
    ["viz_style", "Style", "select", [["led", "LED dot matrix"], ["bars", "Solid gradient bars"], ["wave", "Waveform"]]],
    ["viz_color", "Main color", "color"], ["viz_color_2", "Peaks / gradient color", "color"],
    ["viz_glow", "Glow", "range", { min: 0, max: 100, unit: "%" }],
    ["viz_height", "Height", "range", { min: 10, max: 80, unit: "%" }],
    ["viz_sensitivity", "Sensitivity", "range", { min: 30, max: 250, unit: "%" }],
    ["viz_dot_size", "Dot / bar size", "range", { min: 4, max: 16, unit: "px" }],
    ["viz_mirror", "Mirror from center", "switch"], ["viz_sparkles", "Beat sparkles", "switch"],
  ]],
  ["Station name (top of page)", [
    ["viz_name", "Show station name", "switch"],
    ["name_style", "Look", "select", [["dots", "LED dots"], ["solid", "Solid color text"], ["image", "My logo image (JPG/PNG)"]], { show: (t) => t.viz_name }],
    ["name_image", "Logo image", "image", { show: (t) => t.viz_name && t.name_style === "image" }],
    ["name_size", "Size", "range", { min: 30, max: 170, unit: "%", show: (t) => t.viz_name }],
    ["name_position", "Height on screen", "range", { min: 15, max: 70, unit: "%", show: (t) => t.viz_name }],
  ]],
];

export const PRESETS = [
  ["Lowride Gold", {}],
  ["Candy Red", { label: "#ff3355", station_name: "#ff5c7a", song_title: "#ff3355", song_title_fade: "#ffb3c1", play_button: "#ff3355",
    progress: "#ff3355", volume: "#ff3355", card_border: "#ff3355", viz_color: "#ff1744", viz_color_2: "#ffd1dc",
    text: "#ffe4ea", muted: "#a5717c", bg_mode: "radial", background: "#070203", background_2: "#3a0712", fade_color: "#070203" }],
  ["Chrome Blue", { label: "#7dd3fc", station_name: "#e2e8f0", song_title: "#bae6fd", song_title_fade: "#38bdf8", play_button: "#7dd3fc",
    progress: "#38bdf8", volume: "#38bdf8", card_border: "#7dd3fc", viz_color: "#38bdf8", viz_color_2: "#e0f2fe",
    text: "#e2e8f0", muted: "#7b8ca3", bg_mode: "linear", background: "#020617", background_2: "#0c2a4a", bg_angle: 180,
    fade_color: "#020617", viz_style: "bars", display_font: "Russo One", body_font: "IBM Plex Mono" }],
  ["Purple Haze", { label: "#d8b4fe", station_name: "#f0abfc", song_title: "#e879f9", song_title_fade: "#a855f7", play_button: "#e879f9",
    progress: "#c084fc", volume: "#c084fc", card_border: "#c084fc", viz_color: "#a855f7", viz_color_2: "#f0abfc",
    text: "#f5e8ff", muted: "#9b86ad", bg_mode: "radial", background: "#07020d", background_2: "#2e0a4d", fade_color: "#07020d",
    viz_glow: 60, display_font: "Monoton" }],
  ["Neon Mint", { label: "#5eead4", station_name: "#99f6e4", song_title: "#2dd4bf", song_title_fade: "#a3e635", play_button: "#5eead4",
    progress: "#2dd4bf", volume: "#2dd4bf", card_border: "#2dd4bf", viz_color: "#14b8a6", viz_color_2: "#d9f99d",
    text: "#e6fffa", muted: "#6e9c94", background: "#010806", fade_color: "#010806", viz_style: "wave", viz_glow: 70,
    display_font: "VT323" }],
  ["Old English", { label: "#e5e5e5", station_name: "#ffffff", song_title: "#f5f5f5", song_title_fade: "#a3a3a3", play_button: "#f5f5f5",
    progress: "#d4d4d4", volume: "#d4d4d4", card_border: "#a3a3a3", viz_color: "#d4d4d4", viz_color_2: "#ffffff",
    text: "#f5f5f5", muted: "#8a8a8a", background: "#000000", fade_color: "#000000", display_font: "UnifrakturMaguntia",
    body_font: "Courier Prime", viz_sparkles: false }],
  ["Sunset Cruise", { label: "#fdba74", station_name: "#fed7aa", song_title: "#fb923c", song_title_fade: "#f43f5e", play_button: "#fb923c",
    progress: "#fb923c", volume: "#fb923c", card_border: "#fb923c", viz_color: "#f97316", viz_color_2: "#fde047",
    text: "#fff1e6", muted: "#b08a74", bg_mode: "linear", background: "#12020a", background_2: "#5a1a0a", bg_angle: 200,
    fade_color: "#12020a", viz_style: "bars", display_font: "Pacifico", body_font: "Outfit" }],
];

const loaded = new Set(["Bebas Neue", "Plus Jakarta Sans"]);
export const loadFont = (name) => {
  if (!name || loaded.has(name)) return;
  loaded.add(name);
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(name).replace(/%20/g, "+")}&display=swap`;
  document.head.appendChild(link);
};

const bgFill = (t) => {
  if (t.bg_mode === "linear") return `linear-gradient(${t.bg_angle}deg, ${t.background}, ${t.background_2})`;
  if (t.bg_mode === "radial") return `radial-gradient(ellipse at 50% 20%, ${t.background_2} 0%, ${t.background} 70%)`;
  return t.background;
};

export const themeVars = (t) => {
  if (!t) return {};
  loadFont(t.display_font);
  loadFont(t.body_font);
  return {
    "--t-bg": t.background, "--t-bg-fill": bgFill(t), "--t-dots": t.dot_grid ? t.dot_grid_opacity / 100 : 0,
    "--t-img-opacity": t.bg_image_opacity / 100, "--t-fade": t.fade_color,
    "--t-panel": t.panel, "--t-lcd": t.lcd, "--t-button": t.button, "--t-bar": t.bar, "--t-card-border": t.card_border,
    "--t-text": t.text, "--t-muted": t.muted, "--lr-muted": t.muted,
    "--t-label": t.label, "--t-name": t.station_name, "--t-title": t.song_title, "--t-title2": t.song_title_fade,
    "--t-play": t.play_button, "--t-progress": t.progress, "--t-volume": t.volume,
    "--t-viz": t.viz_color, "--t-viz2": t.viz_color_2,
    "--t-display": `"${t.display_font}", sans-serif`, "--t-body": `"${t.body_font}", sans-serif`,
  };
};

export const vizOptions = (t) => ({
  style: t?.viz_style || "led", glow: t?.viz_glow ?? 30, height: t?.viz_height ?? 36, sensitivity: t?.viz_sensitivity ?? 100,
  pitch: t?.viz_dot_size ?? 8, mirror: t?.viz_mirror ?? true, sparkles: t?.viz_sparkles ?? true, showName: t?.viz_name ?? true,
  nameStyle: t?.name_style || "dots", nameSize: t?.name_size ?? 100, namePos: t?.name_position ?? 36,
});

export const fadeGradient = (strength) =>
  `linear-gradient(to bottom, color-mix(in srgb, var(--t-fade) ${strength * 0.3}%, transparent), color-mix(in srgb, var(--t-fade) ${strength * 0.85}%, transparent) 70%, transparent)`;

// Photo itself fades out toward the bottom so it blends into any page background (solid or gradient).
export const photoMask = (strength) => {
  const end = 100 - strength * 0.4;
  return { WebkitMaskImage: `linear-gradient(to bottom, #000 ${end - 30}%, transparent ${end}%)`, maskImage: `linear-gradient(to bottom, #000 ${end - 30}%, transparent ${end}%)` };
};
